module.exports = __webpack_public_path__ + "img/background018.168742eb.jpg";